"use strict";
const LOAN_TO_VALUE_PERCENT = 0.65;
const LOAN_TO_VALUE_DENOMINATOR = 1e3;
const LOAN_TO_VALUE = LOAN_TO_VALUE_PERCENT * LOAN_TO_VALUE_DENOMINATOR;
export { LOAN_TO_VALUE, LOAN_TO_VALUE_DENOMINATOR, LOAN_TO_VALUE_PERCENT };
